import { EnhancedCard } from 'components/enhanced/card';
import EnhancedDataGrid from 'components/enhanced/data-grid/EnhancedDataGrid';
import { AddButton } from 'components/ui';
import { useCallback, useRef } from 'react';
import { equipmentInvoiceLineService } from 'shared/services';
import { EquipmentInvoiceLinesColumns } from '../equipment-invoice-lines';
import EquipmentInvoicAddLinesDialog from './dialog/EquipmentInvoicAddLinesDialog';

interface EquipmentInvoiceLinesCardProps {
  invoiceId: number;
  contractId: number;
  isOpen: boolean;
  handleOpenDialog: () => void;
  handleCloseDialog: () => void;
}

export const EquipmentInvoiceLinesCard = ({
  invoiceId,
  contractId,
  isOpen,
  handleOpenDialog,
  handleCloseDialog
}: EquipmentInvoiceLinesCardProps) => {
  const columns = EquipmentInvoiceLinesColumns();
  const datagridRefresh = useRef(null);

  const onSubmit = useCallback(
    (values: any) => {
      if (!invoiceId) return;
      equipmentInvoiceLineService
        .update(+values.invoice_line, { document: Number(invoiceId) })
        .then(() => {
          handleCloseDialog();
          datagridRefresh.current?.();
        });
    },
    [invoiceId, handleCloseDialog]
  );
  return (
    <>
      <EnhancedCard
        title="Elenco Voci"
        subtitle="Gestisci le singole voci associate alla fattura"
        buttons={<AddButton onClick={handleOpenDialog} variant="contained" />}>
        <EnhancedDataGrid
          columns={columns}
          service={equipmentInvoiceLineService}
          outerParams={{ document: invoiceId }}
          refresh={datagridRefresh}
        />
      </EnhancedCard>
      <EquipmentInvoicAddLinesDialog
        isOpen={isOpen}
        onClose={handleCloseDialog}
        onSubmit={onSubmit}
        contractId={contractId}
      />
    </>
  );
};

export default EquipmentInvoiceLinesCard;
